import {bindable, customElement, inject} from 'aurelia-framework';
import {ModelLabelService} from './model-label-service';
import * as _ from 'lodash';

/**
 * Class to display an object or a list of objects as a reference with a link
 */
@customElement('reference-display')
@inject(ModelLabelService)
export class ReferenceDisplay {
    @bindable reference;
    @bindable multiModel = false;
    @bindable separator = ', ';
    @bindable renderAsLink = true;
    @bindable labelProperty;
    @bindable maximum = 6;

    links = [];
    additionalReferences = [];

    constructor(modelLabelService) {
        this.modelLabelService = modelLabelService;
    }

    bind() {
        this.referenceChanged();
    }

    referenceChanged() {
        this.links = [];
        this.additionalReferences = [];

        if (!this.reference) {
            return;
        }

        let references = this.reference;

        if (!Array.isArray(references)) {
            references = [references];
        }

        if (this.maximum) {
            this.additionalReferences = references.slice(this.maximum);
            references = references.slice(0, this.maximum);
        }

        references = references.map((reference) => {
            return this.modelLabelService.getReferenceLinks(reference, this.multiModel, this.labelProperty);
        });

        Promise.all(references).then((links) => {

            this.links = [];

            links.forEach(link => {

                if (link) {
                    this.links.push(link);
                }
            });

        });
    }

    clickMaximum()
    {
        this.maximum = null;

        let newReferences = this.additionalReferences.map((reference) => {
            return this.modelLabelService.getReferenceLinks(reference, this.multiModel, this.labelProperty);
        });
        this.additionalReferences = [];

        Promise.all(newReferences).then((links) => {
            links.forEach(link => {

                if (link) {
                    this.links.push(link);
                }
            });
        });
    }
}
